/**
 * Pure compiler for the rapport journalier from the local replica (PRD M09-01): present list from the day's
 * attendance (missing = not recorded), progress first→last per article, needs of the day. Same shape as the
 * server compiler so the on-device preview and the Gotenberg PDF agree.
 */
export function compileDailyReport(input) {
    const att = new Map(input.attendance.map((a) => [a.person_id, a.status]));
    const present = input.team.map((m) => ({ name: m.name_fr, function: m.function ?? null, status: att.get(m.person_id) ?? "non pointé" }));
    const byArticle = new Map();
    for (const e of [...input.progress].sort((a, b) => a.device_ts.localeCompare(b.device_ts)))
        byArticle.set(e.article_id, [...(byArticle.get(e.article_id) ?? []), e]);
    const prior = new Map(input.prior.map((p) => [p.article_id, p.pct]));
    const progress = [...byArticle.entries()].map(([id, events]) => {
        const last = events[events.length - 1];
        return { designation: last.designation_fr, from: prior.get(id) ?? null, to: Number(last.pct ?? 0), comment: events.map((e) => e.comment).filter(Boolean).join(" · ") || null };
    });
    const needs = input.needs.map((n) => ({ designation: n.product_name ?? n.free_text ?? "", qty: Number(n.qty), unit: n.unit ?? null, priority: n.priority }));
    return { chantier: input.chantier, chefChantier: input.chefChantier, date: input.date, weather: input.weather ?? null, present, progress, needs, incidents: input.incidents ?? [], remarks: input.remarks ?? null };
}
//# sourceMappingURL=daily-report.js.map